import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {getAuthHeaders, api } from '../utils/api';

// Async thunk for updating user
export const updateUser = createAsyncThunk(
  'user/updateUser',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await api.patch(`/users/${id}`, data, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const updateUserSlice = createSlice({
  name: 'updateUser',
  initialState: {
    updating: false,
    updateError: null,
    updatedUser: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.updating = true;
        state.updateError = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.updating = false;
        state.updatedUser = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.updating = false;
        state.updateError = action.payload;
      });
  },
});

export default updateUserSlice.reducer;
